import styled from "styled-components";
import {
  Avatar as AntAvatar,
  Input as AntInput,
  Button as AntButton,
  Form as AntForm,
} from "antd";

export const RootContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin: 0 16px ;
  min-height: calc(100vh - 70px);
  gap: 32px;
  overflow: hidden;
`;

export const AvatarWrapper = styled.div`
  margin: 16px 0 0 ;
`

export const Avatar = styled(AntAvatar)`
  border-radius: 12px !important;
`;

export const ProfileInputContainer = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100px;
  height: 28;
  border-radius: 0px 0px 12px 12px;
  background: rgba(8, 10, 10, 0.6);
  display: flex;
  justify-content: center;
  align-items: center; 
`
export const Form = styled(AntForm)`
  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px !important;
  }

  .ant-form-item {
    margin: 0px 0 24px 0;
  }
`

export const InputLabel = styled.p`
  position: absolute;
  left: 24px;
  top: -8px;
  z-index: 30;
  margin: 0px;
  padding: 0px 4px;
  color: #535B5D;
  background-color: white;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Input = styled(AntInput)`
  height: 52px;
  text-align: center;
  border-radius: 34px;
  border: 1.5px solid #DEDEDE;
  background: #FFF;
  -webkit-text-fill-color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
  text-align: left;
  padding: 0 0 0 24px;
  color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  input{
    text-align: left;
    color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const SaveButton = styled(AntButton)`
  box-sizing: border-box !important ;
  position: fixed;
  bottom: 12px;
  width: calc(100% - 30px) !important;
  max-width: 442px;
  height: 52px;
  margin: 0 15px;
  border-radius: 27px !important;
  background-color: #C21C05;
  color: #F7F7F7;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  :hover {
    background-color: #6d1304 !important;
  }
`